import React from 'react';
import { FiTarget, FiUsers, FiShield, FiZap } from 'react-icons/fi';
import Reveal from './Reveal';
import SectionHead from './SectionHead';

const values = [
  {
    icon: FiTarget,
    title: 'Education first',
    text: 'We understand admissions, academics and parents, so you don\u2019t have to explain the basics.'
  },
  {
    icon: FiUsers,
    title: 'One accountable partner',
    text: 'Tech, marketing, content and design under one roof, with a single point of contact.'
  },
  {
    icon: FiShield,
    title: 'Transparent pricing',
    text: 'Fixed quotes, milestone payments and full ownership of everything we build for you.'
  },
  {
    icon: FiZap,
    title: 'Modern technology',
    text: 'Fast, secure and scalable software built on proven, well-supported tools.'
  }
];

const About = () => (
  <section className="section">
    <div className="container split">
      <div>
        <SectionHead eyebrow="Who we are" title="The Fusion of Digital Management for education" />
        <Reveal className="prose">
          <p>
            Fedigma brings every digital need of an educational institution under one roof, whether
            you run a school, college, kindergarten, library or private institute.
          </p>
          <p>
            We build websites and apps, run our own institute ERP, EdTrack Smart, manage digital
            presence and marketing, set up digital classrooms through trusted vendors, write
            educational content, offer career counselling, and handle video editing, graphic design
            and documentation.
          </p>
          <p>
            Fedigma is a brand of Fedigma Forge Pvt Ltd, based in Dwarka, New Delhi. Alongside
            education, we also build custom websites for associations and businesses.
          </p>
        </Reveal>
      </div>

      <div className="values-grid">
        {values.map((value, index) => {
          const ValueIcon = value.icon;
          return (
            <Reveal key={value.title} className="value-card" delay={index * 0.06}>
              <div className="service-icon"><ValueIcon aria-hidden="true" /></div>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default About;
